<template>
  <div id="enter_policy_agree_e" class="enter_policy_agree">
    <span>{{ $t('lang102') }}</span>
    <a href="/agreement.html" target="_blank">
      {{ $t('lang103') }}
    </a>
    <span>,</span>
    <a href="/privacyPolicy.html" target="_blank">{{ $t('lang047') }}</a>

    <div class="enter_policy_agree_left">
      <div v-show="showAgreeTips" class="no_check_remind">
        {{ $t('lang169') }}
      </div>
      <input
        v-model="isAgree"
        class="enter_policy_agree_checkbox"
        type="checkbox"
        name="category"
        @click="$emit('hideAgreeTips')"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  props: {
    showAgreeTips: Boolean
  },
  components: {},
  data() {
    return {
      isAgree: true
    };
  },
  watch: {
    isAgree: {
      handler(val) {
        this.$emit('emitAgree', val);
      },
      immediate: true
    }
  },
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.enter_policy_agree {
  display: inline-block;
  margin: 0 auto;
  margin-top: 15px;
  padding-left: 18px;
  text-align: left;
  position: relative;
  font-size: 12px;
  font-weight: 400;
  color: #8a8f99;
  line-height: 14px;

  &::after {
    display: block;
    content: '';
    clear: both;
  }

  .no_check_remind {
    position: absolute;
    left: 50%;
    top: -42px;
    transform: translate(-50%, 0);
    width: 151px;
    height: 32px;
    background: rgba(0, 228, 209, 1);
    border-radius: 24px;
    font-size: 12px;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    line-height: 32px;
    text-align: center;

    &::after {
      content: '';
      display: block;
      position: absolute;
      left: 50%;
      top: 100%;
      transform: translate(-50%, 0);
      width: 13px;
      height: 7px;
      background: url(~@/assets/img/enter_policy_agree_remind.png) center
        no-repeat;
    }
  }

  .enter_policy_agree_left {
    position: absolute;
    left: 0;
    top: 0;
  }

  input[type='checkbox'] {
    -webkit-appearance: checkbox;
    width: 12px;
    height: 12px;
    border-radius: 2px;
    border: 1px solid #8a8f99;
  }

  .enter_policy_agree_text {
    float: left;
  }

  a {
    color: #2f3033;
  }
}
</style>
